import { ExpandableProse } from '@app/components/base/content-structure/ExpandableProse';
import { useFragment } from '../../hooks/useFragment';
import { FragmentDescription } from './FragmentDescription';

/**
 * Editorial description block shown below the media player.
 * Clamps long prose with show more / show less; no section header.
 */
export function FragmentDescriptionSection() {
  const { fragment } = useFragment();
  const description = fragment.description?.trim();

  if (!description) {
    return null;
  }

  return (
    <ExpandableProse>
      <FragmentDescription description={description} />
    </ExpandableProse>
  );
}
